/* egs-intro-v6-cards 1784882653 */
/**
 * Elisee Graphic Studio
 * - Motore ricerca intelligente (1-shot, no chat)
 * - Filtri categoria + fascia
 * - Selezione multipla + suggerimento pacchetto
 */
(function () {
  'use strict';

  var PRICES = { Basic: 2, Pro: 4, 'Pro Max': 7 };
  var PACKS = {
    Basic: { 5: 8, 10: 14, 20: 25 },
    Pro: { 5: 17, 10: 30, 20: 55 },
    'Pro Max': { 5: 30, 10: 55, 20: 100 }
  };

  var CATEGORIES = [
    { id: 'calcio-sport', name: 'Calcio & Sport', icon: '⚽', keys: ['calcio', 'sport', 'football', 'soccer', 'champions', 'league', 'serie a', 'nba', 'tennis', 'f1', 'motorsport', 'stadio', 'maglia', 'tifo'] },
    { id: 'moda-fashion', name: 'Moda & Fashion Editorial', icon: '👗', keys: ['moda', 'fashion', 'editorial', 'sfilata', 'runway', 'couture', 'abito', 'model', 'vogue', 'lookbook'] },
    { id: 'borse-luxury', name: 'Borse & Accessori Luxury', icon: '👜', keys: ['borsa', 'bag', 'handbag', 'accessori', 'luxury bag', 'clutch', 'wallet', 'cintura'] },
    { id: 'ritratti', name: 'Ritratti Cinematici', icon: '🎬', keys: ['ritratto', 'portrait', 'cinematic', 'volto', 'face', 'headshot', 'attore', 'bellezza volto'] },
    { id: 'prodotto', name: 'Prodotto & E-commerce', icon: '📦', keys: ['prodotto', 'product', 'ecommerce', 'packshot', 'still life', 'catalogo', 'mockup', 'white background'] },
    { id: 'beauty', name: 'Beauty & Makeup', icon: '💄', keys: ['beauty', 'makeup', 'make up', 'trucco', 'skincare', 'lipstick', 'glam'] },
    { id: 'profumi', name: 'Profumi & Fragrance', icon: '🌸', keys: ['profumo', 'fragrance', 'perfume', 'parfum', 'scent', 'flacon'] },
    { id: 'video', name: 'Video & Motion Graphics', icon: '🎥', keys: ['video', 'motion', 'animazione', 'reel', 'storyboard', 'cinemagraph'] },
    { id: 'sneakers', name: 'Sneakers & Streetwear Brand', icon: '👟', keys: ['sneaker', 'sneakers', 'streetwear', 'scarpe', 'nike style', 'kicks', 'hype'] },
    { id: 'retro-vhs', name: 'Retro VHS & Analog', icon: '📼', keys: ['retro', 'vhs', 'analog', 'anni 90', '90s', '80s', 'anni 80', 'film grain', 'polaroid', 'disposable'] },
    { id: 'paper-cut', name: 'Paper Cut & Stop-Motion Craft', icon: '✂️', keys: ['paper cut', 'papercraft', 'stop motion', 'carta', 'craft', 'handmade'] },
    { id: 'food', name: 'Food & Beverage', icon: '🍷', keys: ['food', 'cibo', 'beverage', 'drink', 'birra', 'vino', 'cocktail', 'ristorante', 'piatto'] },
    { id: 'automotive', name: 'Automotive', icon: '🚗', keys: ['auto', 'car', 'automotive', 'supercar', 'motore', 'garage'] },
    { id: 'pixel-gta', name: 'Pixel, GTA & Game Aesthetic', icon: '🎮', keys: ['pixel', 'gta', 'game', 'videogioco', '8bit', 'pixel art'] },
    { id: 'travel', name: 'Lifestyle & Travel', icon: '✈️', keys: ['travel', 'viaggio', 'lifestyle', 'vacanza', 'hotel', 'destinazione'] },
    { id: 'motion-blur', name: 'Motion Blur & Experimental Photo', icon: '🌀', keys: ['motion blur', 'experimental', 'long exposure', 'blur'] },
    { id: 'claymation', name: 'Claymation & 3D Stylized', icon: '🧸', keys: ['claymation', 'clay', '3d stylized', 'pixar style', 'cartoon 3d'] },
    { id: 'luxury-campaign', name: 'Luxury Brand Campaign', icon: '✨', keys: ['luxury campaign', 'brand campaign', 'campagna', 'advertising luxury'] }
  ];

  var FASCIA_KEYS = {
    'Pro Max': ['pro max', 'promax', 'premium', 'top', 'esclusiv', 'cinematic high end', 'ultra'],
    Pro: ['pro', 'avanzat', 'elaborat', 'cinematic', 'editoriale'],
    Basic: ['basic', 'semplice', 'entry', 'base', 'facile', 'veloce']
  };

  function slugify(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function priceOf(fascia) {
    return PRICES[fascia] || PRICES.Basic;
  }

  function packSuggestion(count, fascia) {
    var packs = PACKS[fascia] || PACKS.Basic;
    var unit = priceOf(fascia);
    var singleTotal = count * unit;
    var best = null;

    [5, 10, 20].forEach(function (n) {
      if (count >= n) {
        var packPrice = packs[n];
        var save = singleTotal - packPrice;
        // if they already exceed pack size, compare n singles vs pack is wrong;
        // compare floor packs later — for UI we suggest nearest pack thresholds
      }
    });

    // Suggest next pack tier if close
    var next = null;
    if (count < 5) next = 5;
    else if (count < 10) next = 10;
    else if (count < 20) next = 20;

    if (!next) {
      // already 20+: show 20-pack value
      var p20 = packs[20];
      var singles20 = 20 * unit;
      return {
        kind: 'value',
        message:
          'Con il pacchetto 20 ' +
          fascia +
          ' paghi €' +
          p20 +
          ' invece di €' +
          singles20 +
          ' (risparmi €' +
          (singles20 - p20) +
          ').'
      };
    }

    var need = next - count;
    var packPrice = packs[next];
    var singlesNext = next * unit;
    var save = singlesNext - packPrice;
    var payNow = singleTotal;
    var payIfPack = packPrice; // if they fill to next
    return {
      kind: 'upsell',
      need: need,
      next: next,
      save: save,
      message:
        need === 1
          ? 'Aggiungine 1 e attiva il pacchetto da ' +
            next +
            ' (' +
            fascia +
            '): €' +
            packPrice +
            ' invece di €' +
            singlesNext +
            ' — risparmi €' +
            save +
            '.'
          : 'Aggiungine ' +
            need +
            ' e attiva il pacchetto da ' +
            next +
            ' (' +
            fascia +
            '): €' +
            packPrice +
            ' invece di €' +
            singlesNext +
            ' — risparmi €' +
            save +
            '.'
    };
  }

  /**
   * Interpreta query linguaggio naturale → filtri (1-shot, locale, zero costo API)
   */
  function interpretQuery(q) {
    var raw = String(q || '').trim();
    var lower = raw.toLowerCase();
    var result = {
      query: raw,
      categories: [],
      fasce: [],
      freeText: raw,
      ambiguous: !raw
    };

    if (!raw) {
      result.ambiguous = true;
      return result;
    }

    // Fascia
    Object.keys(FASCIA_KEYS).forEach(function (f) {
      FASCIA_KEYS[f].forEach(function (k) {
        if (lower.indexOf(k) !== -1 && result.fasce.indexOf(f) === -1) {
          result.fasce.push(f);
        }
      });
    });

    // Categorie per keyword score
    var scored = [];
    CATEGORIES.forEach(function (cat) {
      var score = 0;
      cat.keys.forEach(function (k) {
        if (lower.indexOf(k) !== -1) score += k.length >= 5 ? 3 : 2;
      });
      // also match category name pieces
      cat.name.toLowerCase().split(/[\s&/]+/).forEach(function (w) {
        if (w.length > 3 && lower.indexOf(w) !== -1) score += 2;
      });
      if (score > 0) scored.push({ cat: cat, score: score });
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    result.categories = scored.filter(function (s, i) {
      return i === 0 || s.score >= scored[0].score - 1;
    }).map(function (s) { return s.cat; });

    if (!result.categories.length && !result.fasce.length) {
      // keep free text for Shopify search
      result.ambiguous = raw.length < 3;
    } else {
      result.ambiguous = false;
    }

    return result;
  }

  function money(n) {
    return '€' + Number(n).toFixed(2).replace('.00', '');
  }

  function getRoot() {
    return document.querySelector('[data-egs-root]');
  }

  function stateFromRoot(root) {
    return {
      query: '',
      fascia: 'all',
      category: 'all',
      selection: loadSelection(),
      products: [],
      loading: false,
      collectionUrl: root.getAttribute('data-collection-url') || '/collections/elisee-graphic-studio',
      searchScope: root.getAttribute('data-search-tag') || 'Graphic Studio'
    };
  }

  function loadSelection() {
    try {
      return JSON.parse(localStorage.getItem('egs_selection') || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveSelection(sel) {
    try {
      localStorage.setItem('egs_selection', JSON.stringify(sel));
    } catch (e) {}
  }

  function productFascia(p) {
    var tags = (p.tags || []).map(function (t) { return String(t); });
    var joined = tags.join(' ').toLowerCase();
    if (/pro\s*max|fascia:pro\s*max|promax/.test(joined)) return 'Pro Max';
    if (/\bpro\b|fascia:pro/.test(joined) && !/pro\s*max/.test(joined)) return 'Pro';
    if (/basic|fascia:basic/.test(joined)) return 'Basic';
    // option
    if (p.variants && p.variants[0] && p.variants[0].option1) {
      var o = p.variants[0].option1;
      if (/max/i.test(o)) return 'Pro Max';
      if (/pro/i.test(o)) return 'Pro';
      if (/basic/i.test(o)) return 'Basic';
    }
    var price = p.price ? p.price / 100 : 0;
    if (price >= 6) return 'Pro Max';
    if (price >= 3) return 'Pro';
    return 'Basic';
  }

  function productCategory(p) {
    var tags = (p.tags || []).map(String);
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (/^categoria:/i.test(t)) return t.split(':').slice(1).join(':').trim();
      if (/^cat:/i.test(t)) return t.split(':').slice(1).join(':').trim();
    }
    // match known categories in tags/type
    var hay = (tags.join(' ') + ' ' + (p.type || '') + ' ' + (p.product_type || '')).toLowerCase();
    for (var c = 0; c < CATEGORIES.length; c++) {
      if (hay.indexOf(CATEGORIES[c].name.toLowerCase()) !== -1) return CATEGORIES[c].name;
      for (var k = 0; k < CATEGORIES[c].keys.length; k++) {
        if (hay.indexOf(CATEGORIES[c].keys[k]) !== -1) return CATEGORIES[c].name;
      }
    }
    return p.type || p.product_type || 'Prompt AI';
  }

  function normalizeProduct(raw) {
    // supports both /search/suggest and /products.json shapes
    var p = raw;
    if (raw.object) p = raw; // predictive
    var tags = p.tags;
    if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
    if (!tags) tags = [];
    var price = p.price;
    if (price == null && p.variants && p.variants[0]) price = Math.round(parseFloat(p.variants[0].price) * 100);
    if (price != null && price < 50 && String(price).indexOf('.') !== -1) price = Math.round(price * 100);
    // Shopify products.json price is already cents as string sometimes
    if (typeof price === 'string') price = Math.round(parseFloat(price) * (price.indexOf('.') >= 0 ? 100 : 1));

    var img = null;
    if (p.image) img = typeof p.image === 'string' ? p.image : p.image.src;
    if (!img && p.featured_image) img = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src;
    if (!img && p.images && p.images[0]) img = p.images[0].src || p.images[0];
    if (!img && p.featured_media && p.featured_media.preview_image) img = p.featured_media.preview_image.src;

    var url = p.url || (p.handle ? '/products/' + p.handle : '#');
    var id = p.id || p.handle;
    var variantId = p.variants && p.variants[0] ? p.variants[0].id : p.variant_id || null;

    return {
      id: id,
      handle: p.handle,
      title: p.title,
      url: url,
      tags: tags,
      type: p.type || p.product_type || '',
      price: price || 0,
      image: img,
      variantId: variantId,
      fascia: null,
      category: null
    };
  }

  function enrich(p) {
    p.fascia = productFascia(p);
    p.category = productCategory(p);
    if (!p.price) p.price = priceOf(p.fascia) * 100;
    return p;
  }

  function collectionBase(state) {
    return (state.collectionUrl || '/collections/elisee-graphic-studio').replace(/\/$/, '');
  }

  /** URL Shopify filter per tag (categoria o fascia) */
  function filterUrl(state, opts) {
    opts = opts || {};
    var base = collectionBase(state);
    var tags = [];
    var cat = opts.category || state.category;
    var fas = opts.fascia || state.fascia;
    if (cat && cat !== 'all') {
      // tag grezzo + Categoria:X (come in import CSV)
      tags.push(cat);
    }
    if (fas && fas !== 'all') {
      tags.push('Fascia:' + fas);
    }
    if (!tags.length) return base;
    // un solo filter.p.tag per URL (Shopify storefront); se due, usa il primo e lascia client-side
    return base + '?filter.p.tag=' + encodeURIComponent(tags[0]);
  }

  function buildSearchUrl(state, intent) {
    var parts = [];
    if (state.searchScope) parts.push(state.searchScope);
    if (intent.categories && intent.categories[0]) parts.push(intent.categories[0].name);
    if (intent.fasce && intent.fasce[0]) parts.push(intent.fasce[0]);
    if (intent.query) parts.push(intent.query);
    if (state.category && state.category !== 'all') parts.push(state.category);
    if (state.fascia && state.fascia !== 'all') parts.push(state.fascia);
    var q = parts.join(' ').trim() || 'Graphic Studio prompt';
    return '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=50&resources[options][fields]=title,product_type,tag,variants.title,body';
  }

  /** Carica prodotti collection in modo progressivo (prima pagina veloce, resto in background) */
  function fetchCollectionPages(state, maxPages, onBatch) {
    maxPages = maxPages || 4;
    var base = collectionBase(state) + '/products.json?limit=250&page=';
    var all = [];
    var page = 1;

    function next() {
      return fetch(base + page, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('collection ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          all = all.concat(batch);
          if (typeof onBatch === 'function') {
            try { onBatch(all.slice(), page, batch.length < 250 || page >= maxPages); } catch (e) {}
          }
          if (batch.length >= 250 && page < maxPages) {
            page += 1;
            return next();
          }
          return all;
        });
    }
    return next();
  }

  /** CDN Shopify: riduce peso immagini griglia */
  function thumbUrl(src, w) {
    if (!src || typeof src !== 'string') return src || '';
    w = w || 400;
    try {
      if (src.indexOf('/cdn/') === -1 && src.indexOf('shopify.com') === -1) return src;
      // già con width=
      if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + w);
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
    } catch (e) {
      return src;
    }
  }

  function applyFilters(products, state, intent) {
    intent = intent || interpretQuery('');
    var out = products.slice();

    if (state.fascia !== 'all') {
      out = out.filter(function (p) { return p.fascia === state.fascia; });
    }
    if (state.category !== 'all') {
      var cat = state.category.toLowerCase();
      var catKey = cat.replace(/&/g, ' ').replace(/\s+/g, ' ');
      out = out.filter(function (p) {
        var hay = ((p.category || '') + ' ' + (p.tags || []).join(' ') + ' ' + (p.title || '')).toLowerCase();
        return hay.indexOf(cat) !== -1 || hay.indexOf(catKey) !== -1 ||
          hay.indexOf('categoria:' + cat) !== -1;
      });
    }
    if (intent.query) {
      var q = intent.query.toLowerCase();
      var words = q.split(/\s+/).filter(function (w) { return w.length > 2; });
      if (words.length) {
        out = out.filter(function (p) {
          var hay = ((p.title || '') + ' ' + (p.category || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
          return words.some(function (w) { return hay.indexOf(w) !== -1; });
        });
      }
    }
    if (intent.categories && intent.categories.length && intent.query) {
      var names = intent.categories.map(function (c) { return c.name.toLowerCase(); });
      out.sort(function (a, b) {
        var as = names.some(function (n) { return (a.category || '').toLowerCase().indexOf(n) !== -1; }) ? 1 : 0;
        var bs = names.some(function (n) { return (b.category || '').toLowerCase().indexOf(n) !== -1; }) ? 1 : 0;
        return bs - as;
      });
    }
    return out;
  }

  function fetchProducts(state, intent) {
    state.loading = true;
    state._pageSize = state._pageSize || 24;
    state._visible = state._visible || 24;
    render(state);
    intent = intent || interpretQuery(state.query || '');

    // Prima pagina (250) subito → UI veloce; resto in background (max 4 pagine = 1000)
    return fetchCollectionPages(state, 4, function (list, page, done) {
      var products = (list || []).map(normalizeProduct).map(enrich);
      state._allProducts = products;
      state.products = applyFilters(products, state, intent);
      state.loading = false;
      // dopo la prima batch renderizza subito
      if (page === 1 || done) render(state);
    })
      .then(function (list) {
        if (!list.length) {
          return fetch(buildSearchUrl(state, intent), { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.resources && data.resources.results && data.resources.results.products) {
                return data.resources.results.products;
              }
              return [];
            })
            .then(function (fallback) {
              var products = (fallback || []).map(normalizeProduct).map(enrich);
              state._allProducts = products;
              state.products = applyFilters(products, state, intent);
              state.loading = false;
              render(state);
              return state.products;
            });
        }
        var products = (list || []).map(normalizeProduct).map(enrich);
        state._allProducts = products;
        state.products = applyFilters(products, state, intent);
        state.loading = false;
        render(state);
        return state.products;
      })
      .catch(function (err) {
        console.warn('[EGS] load error', err);
        state.products = [];
        state.loading = false;
        render(state);
      });
  }

  function isSelected(state, p) {
    return state.selection.some(function (s) { return String(s.id) === String(p.id) || s.handle === p.handle; });
  }

  function toggleSelect(state, p) {
    if (isSelected(state, p)) {
      state.selection = state.selection.filter(function (s) {
        return String(s.id) !== String(p.id) && s.handle !== p.handle;
      });
    } else {
      state.selection.push({
        id: p.id,
        handle: p.handle,
        title: p.title,
        fascia: p.fascia,
        category: p.category,
        price: p.price,
        variantId: p.variantId,
        url: p.url
      });
    }
    saveSelection(state.selection);
    render(state);
  }

  function selectionStats(sel) {
    var byCat = {};
    sel.forEach(function (s) {
      var key = (s.category || 'Altro') + '||' + (s.fascia || 'Basic');
      if (!byCat[key]) byCat[key] = [];
      byCat[key].push(s);
    });
    var bestGroup = null;
    Object.keys(byCat).forEach(function (k) {
      if (!bestGroup || byCat[k].length > bestGroup.items.length) {
        var parts = k.split('||');
        bestGroup = { category: parts[0], fascia: parts[1], items: byCat[k] };
      }
    });
    var total = sel.reduce(function (sum, s) {
      return sum + (s.price ? s.price / 100 : priceOf(s.fascia));
    }, 0);
    return { byCat: byCat, bestGroup: bestGroup, total: total, count: sel.length };
  }

  function addSelectionToCart(state) {
    var items = state.selection
      .filter(function (s) { return s.variantId; })
      .map(function (s) { return { id: s.variantId, quantity: 1 }; });

    if (!items.length) {
      // fallback: open first product
      if (state.selection[0] && state.selection[0].url) {
        window.location.href = state.selection[0].url;
      }
      return;
    }

    // Shopify cart/add.js accepts one at a time for older themes; use /cart/add.js sequential or form
    var chain = Promise.resolve();
    items.forEach(function (item) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(item)
        });
      });
    });
    chain
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  function renderInterpreted(root, intent) {
    var box = root.querySelector('[data-egs-interpreted]');
    if (!box) return;
    box.innerHTML = '';
    if (!intent || intent.ambiguous && !intent.query) {
      box.classList.remove('is-visible');
      return;
    }
    var chips = [];
    (intent.categories || []).forEach(function (c) {
      chips.push('<span class="egs-chip">📁 ' + c.name + '</span>');
    });
    (intent.fasce || []).forEach(function (f) {
      chips.push('<span class="egs-chip">◆ ' + f + '</span>');
    });
    if (intent.query && !chips.length) {
      chips.push('<span class="egs-chip">🔎 ' + intent.query.replace(/</g, '') + '</span>');
    }
    if (!chips.length) {
      box.classList.remove('is-visible');
      return;
    }
    box.innerHTML = chips.join('') +
      '<button type="button" class="egs-chip egs-chip--clear" data-egs-clear>Azzera</button>';
    box.classList.add('is-visible');
  }

  function renderCategories(root, state) {
    var wrap = root.querySelector('[data-egs-cats]');
    if (!wrap) return;
    wrap.innerHTML = CATEGORIES.map(function (c, i) {
      var active = state.category === c.name ? ' is-active' : '';
      // Link reale alla collection filtrata + data per filtro client
      var href = filterUrl(state, { category: c.name, fascia: 'all' });
      var delay = (0.04 * i).toFixed(2) + 's';
      return (
        '<a class="egs-cat egs-enter' + active + '" href="' + href + '" data-egs-cat="' + c.name.replace(/"/g, '&quot;') + '" style="animation-delay:' + delay + '">' +
          '<span class="egs-cat__icon">' + c.icon + '</span>' +
          '<span class="egs-cat__name">' + c.name + '</span>' +
        '</a>'
      );
    }).join('');
  }

  function renderGrid(root, state) {
    var grid = root.querySelector('[data-egs-grid]');
    var meta = root.querySelector('[data-egs-meta]');
    if (!grid) return;

    if (state.loading) {
      grid.innerHTML = '<div class="egs-loading">Cerco i prompt giusti…</div>';
      if (meta) meta.textContent = '';
      return;
    }

    if (!state.products.length) {
      grid.innerHTML =
        '<div class="egs-empty">' +
        '<p><strong>Nessun risultato preciso</strong></p>' +
        '<p>Prova una categoria qui sotto, oppure scrivi stile + soggetto (es. <em>“campagna profumo cinematico”</em>).</p>' +
        '</div>';
      if (meta) meta.textContent = '0 risultati — mostra le categorie come guida';
      return;
    }

    var total = state.products.length;
    var visible = Math.min(state._visible || 24, total);
    var slice = state.products.slice(0, visible);

    if (meta) {
      meta.textContent = total + ' prompt' +
        (visible < total ? ' · mostro ' + visible : '') +
        (state.fascia !== 'all' ? ' · ' + state.fascia : '') +
        (state.category !== 'all' ? ' · ' + state.category : '');
    }

    var html = slice.map(function (p, idx) {
      var selected = isSelected(state, p);
      var tagClass = p.fascia === 'Pro Max' ? 'egs-tag--max' : p.fascia === 'Pro' ? 'egs-tag--pro' : 'egs-tag--basic';
      var src = thumbUrl(p.image, 400);
      var img = src
        ? '<img class="egs-card__img" src="' + src + '" alt="" loading="lazy" decoding="async" width="400" height="533">'
        : '<div class="egs-card__img egs-card__img--ph">Pass</div>';
      return (
        '<article class="egs-card' + (selected ? ' is-selected' : '') + '" data-id="' + p.id + '">' +
          img +
          '<div class="egs-card__body">' +
            '<div class="egs-card__tags">' +
              '<span class="egs-tag ' + tagClass + '">' + p.fascia + '</span>' +
              (p.category ? '<span class="egs-tag">' + String(p.category).substring(0, 28) + '</span>' : '') +
            '</div>' +
            '<h3 class="egs-card__title"><a href="' + p.url + '">' + (p.title || '').replace(/</g, '') + '</a></h3>' +
            '<div class="egs-card__price">' + money((p.price || 0) / 100) + '</div>' +
            '<div class="egs-card__actions">' +
              '<button type="button" class="egs-btn-primary" data-egs-toggle="' + p.handle + '">' +
                (selected ? '✓ Selezionato' : 'Seleziona') +
              '</button>' +
              '<a href="' + p.url + '">Dettaglio</a>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }).join('');

    if (visible < total) {
      html +=
        '<div class="egs-load-more-wrap">' +
          '<button type="button" class="egs-load-more" data-egs-load-more>Mostra altri (' + (total - visible) + ')</button>' +
        '</div>';
    }
    grid.innerHTML = html;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  /** Deterministic PRNG from string seed */
  function seedHash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  /** QR leggero (pattern CSS-like, senza decine di nodi SVG) */
  function qrSvgFor(id) {
    var h = seedHash('egs-qr-' + id);
    // un solo SVG minimale: finder corners + hash dots
    return (
      '<svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<rect x="0" y="0" width="4" height="4" fill="currentColor"/>' +
        '<rect x="9" y="0" width="4" height="4" fill="currentColor"/>' +
        '<rect x="0" y="9" width="4" height="4" fill="currentColor"/>' +
        '<rect x="1" y="1" width="2" height="2" fill="#111"/>' +
        '<rect x="10" y="1" width="2" height="2" fill="#111"/>' +
        '<rect x="1" y="10" width="2" height="2" fill="#111"/>' +
        '<rect x="' + (5 + (h % 3)) + '" y="' + (5 + ((h >> 3) % 3)) + '" width="2" height="2" fill="currentColor"/>' +
        '<rect x="' + (7 + ((h >> 5) % 2)) + '" y="' + (4 + ((h >> 7) % 3)) + '" width="1" height="1" fill="currentColor"/>' +
        '<rect x="' + (4 + ((h >> 9) % 4)) + '" y="' + (8 + ((h >> 11) % 2)) + '" width="1" height="1" fill="currentColor"/>' +
      '</svg>'
    );
  }

  /* Intro v4 — overlay gestito da inline script in section; qui card + sync UI */
  var INTRO_SEEN_KEY = 'egs_intro_v7';

  function hasSeenIntro() {
    try {
      if (window.__EGS_INTRO__ && typeof window.__EGS_INTRO__.isOpen === 'function' && window.__EGS_INTRO__.isOpen()) {
        return false;
      }
      return sessionStorage.getItem(INTRO_SEEN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markIntroSeen() {
    try {
      sessionStorage.setItem(INTRO_SEEN_KEY, '1');
      sessionStorage.removeItem('egs_intro_v5');
      sessionStorage.removeItem('egs_intro_v4');
      sessionStorage.removeItem('egs_intro_v3');
      sessionStorage.removeItem('egs_intro_seen');
    } catch (e) { /* private mode */ }
  }

  function clearIntroSeen() {
    try {
      sessionStorage.removeItem(INTRO_SEEN_KEY);
      sessionStorage.removeItem('egs_intro_v5');
      sessionStorage.removeItem('egs_intro_v4');
      sessionStorage.removeItem('egs_intro_v3');
      sessionStorage.removeItem('egs_intro_seen');
    } catch (e) {}
  }

  function wantsForceIntro() {
    try {
      return /(?:\?|&)intro=1(?:&|$)/.test(window.location.search || '');
    } catch (e) {
      return false;
    }
  }

  function buildIntroCardsHtml() {
    function faceHtml(c, serial, shortName) {
      return (
        '<div class="egs-float-card__face egs-float-card__face--front">' +
          '<span class="egs-float-card__metal" aria-hidden="true"></span>' +
          '<span class="egs-float-card__serial">' + serial + '</span>' +
          '<div class="egs-float-card__brand">' +
            '<span class="egs-float-card__brand-top">Elisee</span>' +
            '<span class="egs-float-card__brand-main">Graphic Studio</span>' +
            '<span class="egs-float-card__brand-sub">' + shortName + '</span>' +
          '</div>' +
          '<span class="egs-float-card__qr">' + qrSvgFor(c.id) + '</span>' +
          '<span class="egs-float-card__shine" aria-hidden="true"></span>' +
          '<span class="egs-float-card__edge" aria-hidden="true"></span>' +
        '</div>'
      );
    }
    return CATEGORIES.slice(0, 6).map(function (c, i) {
      var h = seedHash(c.id + '-fall-' + i);
      var serial = String(1000 + (h % 9000)).padStart(4, '0');
      var shortName = c.name.length > 26 ? c.name.split(/[&/]/)[0].trim() : c.name;
      var x = 6 + ((h % 820) / 10);
      var dur = 12 + ((h >>> 7) % 40) / 10;
      var delay = -((h >>> 3) % 100) / 10;
      var drift = ((h % 40) - 20);
      var dir = h % 2 === 0 ? 1 : -1;
      var tilt = ((h % 12) - 6);
      var sc = 0.9 + ((h % 12) / 100);
      var spinDur = (dur).toFixed(1);
      return (
        '<div class="egs-float-card" data-slot="' + i + '" data-cat="' + c.id + '" aria-hidden="true" style="' +
          '--fall-x:' + x + '%;' +
          '--fall-dur:' + dur.toFixed(1) + 's;' +
          '--fall-delay:' + delay.toFixed(1) + 's;' +
          '--drift:' + drift + 'px;' +
          '--spin-dir:' + dir + ';' +
          '--spin-dur:' + spinDur + 's;' +
          '--tilt:' + tilt + 'deg;' +
          '--sc:' + sc.toFixed(2) + ';' +
        '">' +
          '<div class="egs-float-card__3d">' +
            faceHtml(c, serial, shortName) +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function removeStrayIntros() {
    document.querySelectorAll('.egs-intro').forEach(function (n) {
      if (n.id === 'egs-intro-boot') return;
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  function unlockPageScroll() {
    try {
      document.documentElement.classList.remove('egs-intro-active');
      document.documentElement.classList.add('egs-intro-done');
      if (document.body) {
        document.body.classList.remove('egs-intro-active');
        document.body.classList.add('egs-intro-done');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('height');
      }
      document.documentElement.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('position');
      document.documentElement.style.removeProperty('height');
    } catch (e) {}
  }

  function playIntro(root, onDone) {
    if (!root) {
      unlockPageScroll();
      if (onDone) onDone();
      return;
    }

    if (wantsForceIntro()) clearIntroSeen();

    var finished = false;
    function finishFromBundle() {
      if (finished) return;
      finished = true;
      markIntroSeen();
      unlockPageScroll();
      root.classList.remove('is-intro-playing');
      root.classList.add('is-intro-done');
      root.querySelectorAll('.egs-tier').forEach(function (el, i) {
        el.classList.add('egs-enter');
        el.style.animationDelay = (0.08 * i).toFixed(2) + 's';
      });
      removeStrayIntros();
      var boot = document.getElementById('egs-intro-boot');
      if (boot && boot.parentNode) {
        try { boot.parentNode.removeChild(boot); } catch (e) {}
      }
      if (onDone) onDone();
    }

    // Sempre prendi l'elemento dal DOM (piu' affidabile di api.el)
    var intro = document.getElementById('egs-intro-boot');
    var alreadyClosed = !intro || intro.getAttribute('data-egs-closed') === '1' || intro.classList.contains('is-done');

    if (!wantsForceIntro() && (hasSeenIntro() || alreadyClosed)) {
      if (intro && intro.parentNode && hasSeenIntro()) {
        try { intro.parentNode.removeChild(intro); } catch (e) {}
      }
      finishFromBundle();
      return;
    }

    if (!intro) {
      // crea fallback overlay con card se manca HTML
      intro = document.createElement('div');
      intro.id = 'egs-intro-boot';
      intro.className = 'egs-intro';
      intro.setAttribute('role', 'dialog');
      intro.innerHTML =
        '<div class="egs-intro__glow" aria-hidden="true"></div>' +
        '<div class="egs-intro__stage" aria-hidden="true"></div>' +
        '<div class="egs-intro__center"><h1 class="egs-intro__title">Elisee<br>Graphic Studio</h1></div>' +
        '<div class="egs-intro__actions"><button type="button" class="egs-intro__enter" data-egs-intro-skip><span class="egs-intro__enter-label">Skip</span></button></div>';
      document.body.appendChild(intro);
      var skipBtn = intro.querySelector('[data-egs-intro-skip]');
      if (skipBtn) {
        skipBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (window.__EGS_INTRO__ && window.__EGS_INTRO__.close) window.__EGS_INTRO__.close();
          else {
            markIntroSeen();
            document.dispatchEvent(new CustomEvent('egs:intro-closed'));
          }
        });
      }
    }

    root.classList.add('is-intro-playing');
    removeStrayIntros();

    if (document.body && intro.parentNode !== document.body) {
      document.body.appendChild(intro);
    }
    intro.hidden = false;
    intro.removeAttribute('hidden');
    intro.style.display = '';
    intro.classList.add('egs-intro');
    intro.classList.remove('is-done');
    if (prefersReducedMotion()) intro.classList.add('is-static');
    else intro.classList.remove('is-static');

    // CARD: sempre reinietta (fix card sparite)
    var stage = intro.querySelector('.egs-intro__stage');
    if (stage) {
      try {
        if (!stage.querySelector('.egs-float-card')) {
          stage.innerHTML = buildIntroCardsHtml();
        }
      } catch (err) {
        console && console.warn && console.warn('EGS intro cards', err);
      }
    }

    document.documentElement.classList.add('egs-intro-active');
    document.documentElement.classList.remove('egs-intro-done');
    if (document.body) {
      document.body.classList.add('egs-intro-active');
      document.body.classList.remove('egs-intro-done');
    }

    // Solo chiusura manuale via evento (Skip / Escape) — NESSUN auto-timeout
    document.addEventListener('egs:intro-closed', function onClosed() {
      document.removeEventListener('egs:intro-closed', onClosed);
      finishFromBundle();
    });

    // Se nel frattempo e' gia chiusa
    if (intro.getAttribute('data-egs-closed') === '1') {
      finishFromBundle();
    }

    // Retry card se DOM non pronto
    [50, 150, 400].forEach(function (ms) {
      setTimeout(function () {
        if (finished) return;
        var el = document.getElementById('egs-intro-boot');
        if (!el || el.getAttribute('data-egs-closed') === '1') return;
        var st = el.querySelector('.egs-intro__stage');
        if (st && !st.querySelector('.egs-float-card')) {
          try { st.innerHTML = buildIntroCardsHtml(); } catch (e) {}
        }
      }, ms);
    });
  }

  function renderDock(root, state) {
    var dock = root.querySelector('[data-egs-dock]');
    if (!dock) return;
    var st = selectionStats(state.selection);
    if (!st.count) {
      dock.classList.remove('is-visible');
      return;
    }
    dock.classList.add('is-visible');
    var title = dock.querySelector('[data-egs-dock-title]');
    var meta = dock.querySelector('[data-egs-dock-meta]');
    var suggest = dock.querySelector('[data-egs-dock-suggest]');
    if (title) title.textContent = st.count + (st.count === 1 ? ' prompt selezionato' : ' prompt selezionati');
    if (meta) meta.textContent = 'Totale singoli: ' + money(st.total);

    if (suggest && st.bestGroup && st.bestGroup.items.length >= 2) {
      var sug = packSuggestion(st.bestGroup.items.length, st.bestGroup.fascia);
      suggest.textContent =
        '📦 Stessa categoria «' + st.bestGroup.category + '» · ' + st.bestGroup.fascia + ' — ' + sug.message;
      suggest.classList.add('is-visible');
    } else if (suggest) {
      suggest.classList.remove('is-visible');
      suggest.textContent = '';
    }
  }

  function render(state) {
    var root = getRoot();
    if (!root) return;
    renderCategories(root, state);
    renderGrid(root, state);
    renderDock(root, state);

    // fascia buttons
    root.querySelectorAll('[data-egs-fascia]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-egs-fascia') === state.fascia);
    });
  }

  function runSearch(state, rawQuery) {
    var intent = interpretQuery(rawQuery);
    state.query = rawQuery || '';
    state._visible = 24;
    var root = getRoot();
    renderInterpreted(root, intent);

    // Se abbiamo già la cache, filtra in locale (istantaneo)
    if (state._allProducts && state._allProducts.length) {
      state.products = applyFilters(state._allProducts, state, intent);
      state.loading = false;
      render(state);
      return;
    }
    fetchProducts(state, intent);
  }

  function readUrlFilters(state) {
    try {
      var params = new URLSearchParams(window.location.search);
      var tag = params.get('filter.p.tag') || params.get('constraint') || '';
      if (!tag) return;
      // tag può essere Fascia:Pro o nome categoria
      if (/^fascia:/i.test(tag)) {
        var f = tag.split(':').slice(1).join(':').trim();
        if (/max/i.test(f)) state.fascia = 'Pro Max';
        else if (/pro/i.test(f)) state.fascia = 'Pro';
        else if (/basic/i.test(f)) state.fascia = 'Basic';
      } else if (/^categoria:/i.test(tag)) {
        state.category = tag.split(':').slice(1).join(':').trim();
      } else {
        // nome categoria grezzo
        var match = CATEGORIES.find(function (c) {
          return c.name.toLowerCase() === tag.toLowerCase();
        });
        if (match) state.category = match.name;
        else if (/pro\s*max/i.test(tag)) state.fascia = 'Pro Max';
        else if (/^pro$/i.test(tag) || /fascia.*pro/i.test(tag)) state.fascia = 'Pro';
        else if (/basic/i.test(tag)) state.fascia = 'Basic';
      }
    } catch (e) {}
  }

  function init() {
    // anti-freeze: sblocca sempre scroll al boot del catalogo
    try { unlockPageScroll(); } catch (e) {}
    if (window.__EGS_INTRO__ && window.__EGS_INTRO__.unlock) {
      try { window.__EGS_INTRO__.unlock(); } catch (e2) {}
    }
    var root = getRoot();
    if (!root) return;
    var state = stateFromRoot(root);
    window.__EGS_STATE__ = state;
    readUrlFilters(state);

    state._visible = 24;
    state._pageSize = 24;

    // Avvia fetch prodotti subito (in parallelo all'intro) ma non blocca
    var productsPromise = fetchProducts(state, interpretQuery(state.query || ''));

    // Intro leggera; al finish aggiorna UI
    playIntro(root, function () {
      render(state);
    });

    // Durante intro: shell leggera; a intro chiusa render completo
    if (hasSeenIntro()) {
      render(state);
    } else {
      var grid = root.querySelector('[data-egs-grid]');
      if (grid && !state.products.length) {
        grid.innerHTML = '<div class="egs-loading">Carico il catalogo…</div>';
      }
      renderCategories(root, state);
    }

    // Prodotti: render se intro gia chiusa; altrimenti playIntro.onDone lo farà
    if (productsPromise && productsPromise.then) {
      productsPromise.then(function () {
        if (hasSeenIntro()) render(state);
      });
    }

    // Se Skip arriva dall'inline dopo i prodotti, re-render
    document.addEventListener('egs:intro-closed', function () {
      render(state);
    });

    var input = root.querySelector('[data-egs-input]');
    var form = root.querySelector('[data-egs-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        runSearch(state, input ? input.value : '');
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var clear = t.closest('[data-egs-clear]');
      if (clear) {
        e.preventDefault();
        if (input) input.value = '';
        state.category = 'all';
        state.fascia = 'all';
        state.query = '';
        renderInterpreted(root, interpretQuery(''));
        // torna alla collection pulita
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', collectionBase(state));
        }
        runSearch(state, '');
        return;
      }

      // Fascia: se è un <a href> lascia navigare; se button, filtra client
      var fasciaBtn = t.closest('[data-egs-fascia]');
      if (fasciaBtn) {
        var fval = fasciaBtn.getAttribute('data-egs-fascia') || 'all';
        // se ha href e non modifier, lascia navigazione nativa
        if (fasciaBtn.tagName === 'A' && fasciaBtn.getAttribute('href') && !e.metaKey && !e.ctrlKey) {
          // naviga alla collection filtrata (affidabile su Shopify)
          return;
        }
        e.preventDefault();
        state.fascia = fval;
        runSearch(state, input ? input.value : state.query);
        return;
      }

      var catBtn = t.closest('[data-egs-cat]');
      if (catBtn) {
        // Link <a>: navigazione nativa alla collection filtrata
        if (catBtn.tagName === 'A' && catBtn.getAttribute('href') && !e.metaKey && !e.ctrlKey) {
          return; // lascia aprire la pagina filtrata
        }
        e.preventDefault();
        var name = catBtn.getAttribute('data-egs-cat');
        state.category = state.category === name ? 'all' : name;
        runSearch(state, input ? input.value : state.query);
        return;
      }

      var toggle = t.closest('[data-egs-toggle]');
      if (toggle) {
        var handle = toggle.getAttribute('data-egs-toggle');
        var p = state.products.find(function (x) { return x.handle === handle; });
        if (p) toggleSelect(state, p);
        return;
      }

      var clearSel = t.closest('[data-egs-clear-sel]');
      if (clearSel) {
        state.selection = [];
        saveSelection([]);
        render(state);
        return;
      }

      var loadMore = t.closest('[data-egs-load-more]');
      if (loadMore) {
        e.preventDefault();
        state._visible = (state._visible || 24) + (state._pageSize || 24);
        render(state);
        return;
      }

      var toCart = t.closest('[data-egs-to-cart]');
      if (toCart) {
        addSelectionToCart(state);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // export for debugging / optional AI endpoint later
  window.EliseeGraphicStudio = {
    interpretQuery: interpretQuery,
    packSuggestion: packSuggestion,
    PRICES: PRICES,
    PACKS: PACKS,
    CATEGORIES: CATEGORIES,
    resetIntro: clearIntroSeen,
    playIntro: function () {
      clearIntroSeen();
      var root = getRoot();
      if (root) playIntro(root, function () { render(window.__EGS_STATE__ || stateFromRoot(root)); });
    }
  };
})();
